
import {Component, Prop} from "vue-property-decorator";
import {
    HcPageModel,
} from "@dev/hc-components";
import IEndpoints from "@/module/main/model/applicationForm/IEndpoints";

@Component
export default class Endpoints extends HcPageModel
{
    @Prop({type: Object}) public value!: IEndpoints;

    protected pageName: string = "endpoints";

    private isReturnUrlData: object[] = [
        {
            label: this.$localize("pg-main-return-merchantUrl"),
            value: "true"
        },
        {
            label: this.$localize("pg-main-return-callMe"),
            value: "false"
        }
    ];
}
